<template>
    <div class="back-div">
        <div class="main-page" ref="mainPage">
            <iframe v-show="true" ref="gameIframe" :src="gameUrl" frameborder="0" scrolling="no" width="100%" height="100%"></iframe>
        </div>
    </div>
</template>

<script>

import {request} from '@/api/request'
import {Toast} from 'vant'

export default {
    name: 'youyougu',//游游谷 联运
    data() {
        return {
            u_token: '',
            time: '',
            localUserId: '',
            gameUrl: '',
            gameId: '',
            //sdkUrl: 'https://tao648.cn/static/js/taohuali.sdk.js',
            //sdkInstance: {},
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                this.gameId = to.params.gameId;
            },
        }
    },
    mounted() {
        this.u_token = this.$route.query.u_token;
        this.time = this.$route.query.time;

        //localStorage.setItem("gameId", this.gameId);
        this.getGameUrl();
        this.initListener();
    },
    methods: {
        getGameUrl() {
            console.log('gameId:' + this.gameId);
            if (!this.gameUrl) {
                let options = {
                    url: "/dispatch/youyougu/getGameUrl",
                    data: {
                        time: this.time,
                        token: this.u_token,
                        gameId: this.gameId,
                    }
                };
                request(options).then(res => {
                    if (res.data.success) {
                        if (res.data.data.screenType === 1) {
                            this.$refs.mainPage.style.maxWidth = "600px";
                        }
                        this.gameUrl = res.data.data.loginUrl;
                        this.localUserId = res.data.data.userId;
                        console.log('返回游戏页面', this.gameUrl);
                    } else {
                        Toast.fail('拉取游戏数据异常');
                    }
                });
            }
        },
        initListener() {
            window.addEventListener("message", this.listener);
        },
        listener(event) {
            let me = this;
            if (event.data.operation === 'pay') {
                console.log("sdk触发支付");
                let order = event.data.param;
                me.preOrder(order);
            } else if (event.data.operation === 'uploadGameRole') {
                console.log("sdk触发角色上报");
                let param = event.data.param;
                me.uploadRole(param);
            } else if (event.data.operation === 'repeatLogin') {
                console.log("sdk触发登陆被顶");
                me.logout();
            }
        },
        preOrder(order) {
            order.cpOrder = order.cpOrderId;
            let options = {
                url: "/dispatch/youyougu/preOrder",
                data: order
            };

            request(options).then(res => {
                if (res.data.success) {
                    //将订单信息整理调起支付界面
                    let data = res.data.data;
                    let money = parseInt(order.money) / 100;
                    let sdkOrder = {
                        type: 'pay',
                        appid: data.gameId,
                        uid: data.uid,
                        cporderid: data.orderId,
                        serverid: order.serverId,
                        servername: order.serverName,
                        role_name: order.roleName,
                        charid: order.roleId,
                        extinfo: order.cpExt ,
                        money: money,
                        goods_name: order.goodsName,
                        sign: data.sign
                    };
                    //调起订单
                    console.log('预下单参数', JSON.stringify(sdkOrder));
                    parent.postMessage(sdkOrder,'*');
                } else {
                    Toast.fail(res.data.error.message);
                }
            });
        },
        uploadRole(roleParam) {
            let options = {
                url: "/dispatch/youyougu/roleSync",
                data: roleParam
            };

            request(options).then(res => {
                if (res.data.success) {
                    console.log("上报后台角色信息成功");
                    let sdkRole = {
                        type: 'role',
                        uid: res.data.data.userId,
                        appid: res.data.data.gameId,
                        serverid: roleParam.serverId,
                        servername: roleParam.serverName,
                        charid: roleParam.roleId,
                        role_name: roleParam.roleName,
                        level: roleParam.roleLevel,
                        power: roleParam.combatNum,
                        sign: res.data.data.sign
                    }

                    parent.postMessage(sdkRole,'*');
                } else {
                    console.log("上报后台角色信息失败");
                }
            });
        },
        logout() {
            console.log("登出");
        },
    }
}
</script>

<style scoped lang="scss">
.back-div {
    background-color: #eceaea;

    .main-page {
        position: relative;
        background-color: #ffffff;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        touch-action: none;
        margin: 0 auto;

        .main-dialog {

        }

        .loading-dialog {
            position: fixed;
            top: 40%;
            left: 20%;
            width: 60%;
            height: 5rem;
        }
    }
}


</style>
